export function keysOf(value) {
    return Object.keys(value);
}
